<script lang="ts" setup>
import { computed, ref } from 'vue'

import { useTracksLiveKit } from '../../model/tracks-live-kit.hook'
import { useMediaBindingLiveKit } from '../../model/media-binding-live-kit.hook'
import { useRoomLiveKit } from '../../model/room-live-kit.hook'

defineOptions({
  name: 'ScreenShareTile',
})

const { remoteScreenTrack } = useTracksLiveKit()
const { remoteName } = useRoomLiveKit()

const videoEl = ref<HTMLVideoElement | null>(null)

useMediaBindingLiveKit(videoEl, remoteScreenTrack)

const label = computed<string>(() => (remoteName.value ? `${remoteName.value}’s sharing` : 'Screen sharing'))
</script>

<template>
  <div class="screen-share-tile">
    <video
      ref="videoEl"
      class="screen-share-tile__video"
      autoplay
      playsinline
      muted
    />
    <span class="screen-share-tile__label btly-text-body-l">{{ label }}</span>
  </div>
</template>

<style scoped lang="scss" src="./ScreenShareTile.scss" />
